var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.layout && _vm.layout.showSettingsIcon)?_c('v-btn',{attrs:{"icon":""},on:{"click":() => _vm.changeSettingsDialogVisibility(true)}},[_c('v-icon',[_vm._v("mdi-settings")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }